//

import {
  findDuplicateArrayEntries,
  logError,
} from '../../../utils';

const findDuplicateQrAttribute = (key, allQrs, type, removeDuplicateSpaces = true) => {
  if ((key === 'qrLbl') && (!type)) {
    logError(
      `findDuplicateQrAttribute key=${key}, type=${type}`,
      'findDuplicateQrAttribute.missingType',
      {
        key,
        type,
        allQrsCount: allQrs?.length,
      },
    );
  }

  const filteredQrs = (type)
    ? allQrs.filter((thisQr) => (thisQr.qrType === type))
    : allQrs;

  const duplicatesArray = findDuplicateArrayEntries(
    filteredQrs.map((qr) => (qr[key]
                            && (removeDuplicateSpaces
                              ? qr[key].replace(/\s+/g, ' ').trim()
                              : qr[key]))),
    [],
    true,
  );

  return duplicatesArray;
};

export default findDuplicateQrAttribute;
